
import request from '../../Helpers/Request';

class Requests {
    constructor(settings) {
        this.settings = settings;
    }

    index(params) {
        return new Promise((resolve, reject) => {
            request('GET', '/admin/requests', this.settings, null, true, params)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    allow(ClientId, SubscriptionOptionId) {
        return new Promise((resolve, reject) => {
            request('PATCH', '/admin/requests/allow', this.settings, {
                client_id: ClientId,
                subscription_option_id: SubscriptionOptionId,
            })
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    disallow(ClientId, SubscriptionOptionId) {
        return new Promise((resolve, reject) => {
            request('PATCH', '/admin/requests/disallow', this.settings, {
                client_id: ClientId,
                subscription_option_id: SubscriptionOptionId,
            })
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Requests;
